import { useEffect, useState } from "react";
import { Modal, Form, Select, message } from "antd";
import {
    get_subscription_plansApi,
    assign_user_subscriptionApi,
} from "../../api/admin.billing.apis";

const { Option } = Select;

const AssignPlanModal = ({ visible, user, onClose, onSuccess }) => {
    const [form] = Form.useForm();
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(false);
    const [plansLoading, setPlansLoading] = useState(false);

    useEffect(() => {
        if (visible) {
            fetchPlans();
            if (user?._id) {
                form.setFieldsValue({ user_id: user._id });
            }
        }
    }, [visible, user, form]);

    const fetchPlans = async () => {
        try {
            setPlansLoading(true);
            const response = await get_subscription_plansApi(true);
            if (response.data.status === "success") {
                setPlans(response.data.data?.plans || []);
            }
        } catch (error) {
            console.error(error);
            message.error("Failed to load subscription plans");
        } finally {
            setPlansLoading(false);
        }
    };

    const handleFinish = async (values) => {
        try {
            setLoading(true);
            const payload = {
                user_id: values.user_id || user?._id,
                plan_id: values.plan_id,
            };
            const response = await assign_user_subscriptionApi(payload);
            if (response.data.status === "success") {
                message.success("Subscription plan assigned");
                form.resetFields();
                onSuccess?.();
                onClose();
            } else {
                message.error(response.data.message || "Failed to assign plan");
            }
        } catch (error) {
            console.error(error);
            message.error("Failed to assign subscription plan");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={user ? `Assign Plan — ${user.email}` : "Assign Subscription Plan"}
            open={visible}
            onCancel={onClose}
            onOk={() => form.submit()}
            confirmLoading={loading}
            destroyOnClose
        >
            <Form form={form} layout="vertical" onFinish={handleFinish}>
                <Form.Item
                    name="plan_id"
                    label="Subscription Plan"
                    rules={[{ required: true, message: "Select a plan" }]}
                >
                    <Select placeholder="Select plan" loading={plansLoading}>
                        {plans.map((p) => (
                            <Option key={p._id} value={p._id}>
                                {p.name} — {p.general_quota_limit} req/mo
                                {p.amount > 0 ? ` (${p.currency} ${p.amount})` : " (Free)"}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AssignPlanModal;
